/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates.
 * The Universal Permissive License (UPL), Version 1.0
 * as shown at https://oss.oracle.com/licenses/upl/
 * @ignore
 */

import { RectProps } from '../utils/UNSAFE_visTypes/common';

export const Rect = ({
  x,
  y,
  width,
  height,
  scaleX,
  scaleY,
  tx,
  ty,
  fill,
  stroke,
  strokeWidth = 1,
  dataInfo,
  isInteractive
}: RectProps) => {
  return (
    <rect
      x={x + tx}
      y={y + ty}
      width={width * scaleX}
      height={height * scaleY}
      fill={fill}
      stroke={stroke}
      cursor={isInteractive ? 'pointer' : undefined}
      strokeWidth={strokeWidth}
      {...dataInfo}
      vectorEffect="non-scaling-stroke"
    />
  );
};
